export const ScopeCardContent = ({
  icon: Icon,
  title,
  subtitle,
}: {
  icon: React.ComponentType<{ className?: string }>;
  title: string;
  subtitle: string;
}) => (
  <div className='flex flex-col gap-1 ml-4 text-left'>
    <div className='flex items-center gap-2'>
      <Icon className='w-5 h-5 text-primary' />
      <p className='text-primary text-subtitle-m'>{title}</p>
    </div>
    <p className='text-tertiary text-body-m'>{subtitle}</p>
  </div>
);
